var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.45,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.39 3c-4.87 0-6.53 3.56-6.53 11.87V63c0 3.79.48 7.24 8.67 7.24 13.88 0 24.8-12.23 29.55-24.22l2.37.83L61.6 80c-.59-1.19-2-1.66-3.56-1.78s-3.04-.12-4.27-.12H0v-3c4.87 0 6.53-3.56 6.53-11.87V14.84C6.53 6.53 4.87 3 0 3V0h37.27z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MS40NSIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDcxLjQ1IDgwIj4KICA8cGF0aCBkPSJNMzcuMzksM2MtNC44NywwLTYuNTMsMy41Ni02LjUzLDExLjg3VjYzYzAsMy43OS40OCw3LjI0LDguNjcsNy4yNCwxMy44OCwwLDI0LjgtMTIuMjMsMjkuNTUtMjQuMjJsMi4zNy44M0w2MS42LDgwYy0uNTktMS4xOS0yLTEuNjYtMy41Ni0xLjc4UzU1LDc4LjEsNTMuNzcsNzguMUgwdi0zYzQuODcsMCw2LjUzLTMuNTYsNi41My0xMS44N1YxNC44NEM2LjUzLDYuNTMsNC44NywzLDAsM1YwSDM3LjI3WiIgZmlsbD0iI2U4ZmZhMiIvPgo8L3N2Zz4K";
export { SvgLetterL as ReactComponent };